
import { useEffect } from "react";
import logo from "../../assets/images/logo.svg";
import { Link, useParams } from "react-router-dom";
import Spinner from "@/components/Spinner";
import ErrorBox from "@/components/Error/Box";
import { CreateBot } from "@/components/Dialogs/CreateBot";
import { useQuery } from "@tanstack/react-query";
import BotDisplay from "./Developers/BotDisplay";
export default function Developers({ query }: { query: any }) {
    const isActive = (path: string) => window.location.pathname === path;
    document.title = "Developers";

    const {botId} = useParams();
    useEffect(() => {
        if (!query.isLoading && !query.isError && !query.data?.user) {
            window.location.href = "/";
        }
    }, [query]);

    const myBots = useQuery({
        queryKey: ["bots"],
        retry: 1,
        retryDelay: 1000,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const response = await fetch(`__SITE_BASE__/api/v1/bots`);
            return response.json();
        }
    });


    return (
        <>
            {query.isLoading && !query.data?.user ? (
                <Spinner />
            ) : query.isError ? (
                <ErrorBox message={query.error as unknown as string} />
            ) : (
                <>
                    <div className="bg-brand-default w-full sticky top-0 z-50 border-b-2 border-brand-back">
                        <div className="px-2 lg:px-64 py-4">
                            <div className="justify-between items-center flex">
                                <div className="flex items-end gap-2 hover:cursor-pointer" onClick={() => window.location.href = '/'}>
                                    <div className="flex items-center gap-1">
                                        <img src={logo} alt="logo" className="w-10 h-10" />
                                        <h1 className="text-xl text-white font-bold">
                                            Teamly
                                        </h1>
                                    </div>
                                    <div className="text-sm text-white rounded bg-brand-green px-2 items-end">
                                        <p>DEV</p>
                                    </div>
                                </div>
                                <div className="flex items-center space-x-4 text-lg">

                                    <Link to="/">
                                        <button className="text-white hover:bg-brand-back rounded-lg px-2">Go Back</button>
                                    </Link>

                                </div>
                            </div>
                        </div>
                    </div>

                    {botId ? (
                        <BotDisplay botId={botId} user={query} />
                    ) : (
                    <div className="flex h-screen flex-col sm:pb-0 pb-16">
                        <div className="flex h-screen overflow-hidden">

                            <div className={`hidden sm:flex flex-col h-screen bg-brand-dark absolute sm:relative w-96 transition-all duration-300 ease-linear border-r border-brand-back`}>

                                <div className="flex flex-col gap-2 px-4 p-2 py-6 flex-grow">
                                    <Link to="/" className={`flex items-center gap-2 p-2 rounded-lg hover:bg-brand-darkest cursor-pointer ${isActive('/developers') ? 'bg-brand-darkest' : ''}`}>
                                        <h1 className="text-gray-300 font-semibold text-lg hover:text-white">Bots</h1>
                                    </Link>
                                </div>

                            </div>
                            <div className="flex flex-col w-full p-4">
                                <div className="flex">
                                    <div className="flex flex-col w-full gap-4">
                                        <div className="justify-between w-full items-center flex">
                                            <h1 className="text-2xl font-bold text-white">Bots</h1>
                                            <CreateBot>
                                                <button className="bg-brand-green px-5 py-2 rounded-lg text-white font-semibold hover:bg-green-500">Create Bot</button>
                                            </CreateBot>
                                        </div>
                                    </div>
                                </div>
                                
                                {myBots.isLoading && <Spinner />}
                                {myBots.isError && <ErrorBox message={myBots.error as unknown as string} />}

                                <div className="items-center justify-center gap-2 grid grid-cols-1 sm:grid-cols-8 mt-4">
                                {myBots.data?.data && (
                                    myBots.data.data.map((bot: any, index: number) => (
                                        <Link key={index} className="flex flex-col items-center gap-2 sm:max-w-40 py-2 hover:bg-brand-dark transition-all bg-brand-back rounded-lg" to={`/developers/bots/${bot.id}`}>
                                            <div className="border-2 border-brand-green rounded-lg">
                                                {bot.profilePicture ? (
                                                    <img src={bot.profilePicture} alt="Bot Icon" className="h-32 w-32 rounded-lg" />
                                                ) : (
                                                    <div className="h-32 w-32 rounded-lg bg-brand-darkest flex items-center justify-center text-white text-4xl font-semibold">
                                                        {bot.name[0].toUpperCase()}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="flex">
                                                <h1 className="text-white font-semibold">{bot.name}</h1>
                                            </div>
                                        </Link>
                                    ))
                                )}
                                </div>
                                    

                            </div>
                        </div>
                    </div>
                    )}
                </>
            )}
        </>
    );
}
